import { render, staticRenderFns } from "./managers.vue?vue&type=template&id=4f45a66f&scoped=true&lang=pug"
import script from "./managers.vue?vue&type=script&lang=js"
export * from "./managers.vue?vue&type=script&lang=js"
import style0 from "./managers.vue?vue&type=style&index=0&id=4f45a66f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f45a66f",
  null
  
)

export default component.exports